import Inputs from './inputs'

export default Inputs;